import React, {Component} from 'react';

import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {Link} from "react-router-dom";
import {GiveAccessAdAccountModal} from "./GiveAccessAdAccountModal";
import {AgencyHeader} from "./Header";
import {CreateAdAccountModal} from "./CreateAdAccountModal";
import {AdAccountRow} from "./AdAccountRow";
import {withRouterParams} from "../../utils/withRouterParams";


class AdAccountList extends Component {
    constructor(props) {
        super(props);

        this.afterSuccessfulGiveAccessAdAccountSubmit = this.afterSuccessfulGiveAccessAdAccountSubmit.bind(this);
    }

    afterSuccessfulGiveAccessAdAccountSubmit() {
        alert("El acceso se ha otorgado satisfactoriamente");
    }

    render() {
        return (
            <AdAccountListContent
                afterSuccessfulGiveAccessAdAccountSubmit={this.afterSuccessfulGiveAccessAdAccountSubmit}
            />
        )
    }
}


class AdAccountListContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            adAccountsData: null,
            canEditManagerAdSpentLimit: null,
            canCreateAdAccounts: null,
            canGiveAccessToAdAccounts: null,
            adAccountGivingAccess: null
        };

        this.handleAdAccountGaveAccess = this.handleAdAccountGaveAccess.bind(this);
        this.handleAdSpentLimitEdited = this.handleAdSpentLimitEdited.bind(this);
        this.handleAdAccountCreated = this.handleAdAccountCreated.bind(this);
    }

    componentDidMount() {
        this.updateAdAccountList();
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    updateAdAccountList() {
        new APIClient(API_URL + 'manage-accounts/').call('GET').then((respond) => {
            if (respond.status === 'ERROR_NO_AGENCY') {
                alert(respond['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (respond.status === 'OK') {
                this.setState({
                    adAccountsData: respond.data.ad_accounts_data,
                    canEditManagerAdSpentLimit: respond.data.can_edit_manager_adspent_limit,
                    canCreateAdAccounts: respond.data.can_create_ad_accounts,
                    canGiveAccessToAdAccounts: respond.data.can_give_access_to_ad_accounts
                });
            }
        })
    }

    handleAdAccountCreated() {
        alert('La cuenta se ha creado exitosamente.');
        this.updateAdAccountList();
    }

    handleAdSpentLimitEdited() {
        this.updateAdAccountList();
    }

    handleAdAccountGaveAccess() {
        this.updateAdAccountList();
    }

    render() {
        return (
            <section className="section-content">
                <AgencyHeader/>
                <div className="filters">
                    <ul className={'tabs -first'}>
                        <li>
                            <Link className="tab-button" to="/manage-accounts">
                                Administración de Cuentas
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="section-body h-items">
                    <div className="section-body-item -wider box">
                        <header className="box-header">
                            <h2 className="box-title"></h2>
                            {this.renderCreateAdAccount()}
                            {this.renderAdAccountGiveAccessModal()}
                        </header>
                        {this.renderAdAccountList()}
                    </div>
                </div>
            </section>
        )
    }

    renderAdAccountGiveAccessModal() {
        return (
            <GiveAccessAdAccountModal ref={instance => {
                this.giveAccessAdAccountModal = instance;
            }}
                                      afterSuccessfulSubmit={this.props.afterSuccessfulGiveAccessAdAccountSubmit}
            />)
    }

    renderAdAccountList() {
        if (this.state.adAccountsData !== null) {
            return (
                <div className="table-box">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th>Cuenta</th>
                            <th>Inv. Hoy</th>
                            <th>Límite diario</th>
                            <th>Inv. Total</th>
                            <th>Límite Total</th>
                            {/*<th>Chat</th>*/}
                            <th/>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderAdAccounts()}
                        </tbody>
                    </table>
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    renderCreateAdAccount() {
        if (this.state.canCreateAdAccounts)
            return (<CreateAdAccountModal onAdAccountCreated={this.handleAdAccountCreated}/>)
    }

    renderAdAccounts() {
        if (!this.state.adAccountsData)
            return;

        const canGiveAccessToAdAccounts = this.state.canGiveAccessToAdAccounts;
        const canEditManagerAdSpentLimit = this.state.canEditManagerAdSpentLimit;
        const giveAccessAdAccountModal = this.giveAccessAdAccountModal;
        return this.state.adAccountsData.map((adAccountData) => {
            return (<AdAccountRow key={adAccountData.channel + adAccountData.account_id}
                                  level={"1"}
                                  adAccountData={adAccountData}
                                  canEditManagerAdSpentLimit={canEditManagerAdSpentLimit}
                                  canGiveAccessToAdAccounts={canGiveAccessToAdAccounts}
                                  giveAccessAdAccountModal={giveAccessAdAccountModal}
            />);
        });
    }
}


export default withRouterParams(AdAccountList);